import { render, staticRenderFns } from "./ContainerAttachment.vue?vue&type=template&id=65d3f71d&scoped=true&"
import script from "./ContainerAttachment.vue?vue&type=script&lang=js&"
export * from "./ContainerAttachment.vue?vue&type=script&lang=js&"
import style0 from "./ContainerAttachment.vue?vue&type=style&index=0&id=65d3f71d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d3f71d",
  null
  
)

export default component.exports